import api from '.';

class Profile {
  static async updateProfile(data) {
    const user = await api.put('/profile', data);
    return user?.data;
  }
}

export default Profile;
